// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

export const prettifyDisablementType = (disablementType: string): string => {
  switch (disablementType) {
    case 'NoneOrNotProvided':
      return 'None Or Not Provided';
    case 'GlobalLock':
      return 'Global Lock';
    case 'DOChill':
      return 'DO Chill';
    case 'ComplianceLock':
      return 'Compliance Lock';
    case 'SecurityLock':
      return 'Security Lock';
    default:
      return disablementType;
  }
};
